<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5">
            <h1 class="display-2 font-weight-medium">4<i class="bx bx-buoy bx-spin text-primary display-3"></i>3</h1>
            <h4 class="text-uppercase">
              {{ $t("common.forbidden") }}
            </h4>
            <div class="mt-5 text-center">
              <b-button variant="primary" @click="go(-1)"> <i class="bx bx-arrow-back align-middle"></i> {{ $t("common.go-to-back") }} </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/error-img.png" alt class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    go(path) {
      this.$router.go(path);
    },
  },
};
</script>
